/*global angular */
/*jslint node: true */
'use strict';

require('./msTutor/msTutor.js');
require('./msTutor/msTutorTutorials.js');
require('./msVideobackground.js');
require('./msColorPicker/msColorPicker.js');
require('./msPadding/msPadding.js');
require('./msFeedbackAgent/msFeedbackAgent.js');
require('./msCarousel.js');
require('./msTab.js');

var msExt = angular.module('msExt', [
    'msTutor',
    'msTutorTutorials',
    'msVideobackground',
    'msColorPicker',
    'msPadding',
    'msCarousel',
    'msTab',
    'msFeedbackAgent'
]);


/**
 * returns the module components
 * example: listModuleComponents('msExt') result: [['msTab', 'service']]
 *
 * @param mod {String} - module name
 * @returns {[String,String]}
 */
function listModuleComponents(mod) {
    var result = [];
    angular.forEach(angular.module(mod).requires, function (m) {
        result = result.concat(listModuleComponents(m));
    });
    //noinspection JSUnresolvedVariable
    angular.forEach(angular.module(mod)._invokeQueue,
        function (a) {
            result.push([a[2][0], a[1]]); // a[1] == type == factory|directive|...
        });
    return result;
}


/**
 * extInject
 */
msExt.directive('extInject', ['$compile', 'msExt', function ($compile, msExt) {
    var toolbarTestEnabled = false;

    return {
        restrict: 'A',
        /**
         * @param scope {angular.IScope|{}}
         * @param _element {jqLite|[HTMLElement]|*}
         * @param attributes {{extInject: string}|*}
         */
        link: function (scope, _element, attributes) {
            /**
             * the subject_type currently 'site' or 'section'
             * @type {string}
             */
            var subject_type = attributes.extInject;

            /** @type {HTMLElement} */
            var element = _element[0];

            /** @type {msSite|msSection|msSlot} */
            var subject;
            if (subject_type == 'site') {
                subject = scope.site;
            } else if (subject_type == 'section') {
                subject = scope.section;
            } else if (subject_type == 'slot') {
                subject = scope.slot;
            }

            var callback = function (newVal, oldVal) {
                if (!angular.isObject(newVal)) newVal = {};
                if (!angular.isObject(oldVal)) oldVal = {};

                angular.forEach(oldVal, function (value, key) {
                    if (!newVal.hasOwnProperty(key)) newVal[key] = null;
                });

                angular.forEach(newVal, function (value, ext_name) {
                    if (value != oldVal[ext_name]) {
                        if (value) {
                            var ext = msExt.getExtension(ext_name);
                            if (ext && ext.service.injectDirective) {
                                ext.service.injectDirective(scope, _element);
                            }
                        }
                    }

                });
            };


            if (subject_type == 'site') {
                scope.$watch('site.settings.msExt', callback, true);

            } else if (subject_type == 'section') {
                msExt.registerSection(scope.section, element);
                scope.$on('$destroy', function () {
                    msExt.unregisterSection(scope.section);
                });
                scope.$watch('section.settings.msExt', callback, true);
            } else if (subject_type == 'slot') {
            }

            if (toolbarTestEnabled && (subject_type == 'section' || subject_type == 'slot')) {
                var linkFn = $compile('<div ng-if="slot.edit||section.edit" class="btn-group" style="position: absolute;top:-37px;left:7px;background-color: white;">' +
                    '<button type="button"><i class="fa fa-bold"></i></button>' +
                    '<button type="button" ng-click=""><md-icon class="keyboard-arrow" md-font-library="material-icons">keyboard_arrow_up</md-icon></button>' +
                    '</div>');
                var subE = linkFn(scope);
                angular.element(element).append(subE);
                //angular.element(element.children[0]).append(subE); // for sections
            }

            if (subject && subject.settings && subject.settings.msExt) {
                angular.forEach(subject.settings.msExt, function (value, ext_name) {
                    if (value === true) {
                        var ext = msExt.getExtension(ext_name);
                        if (!ext || !ext.service.injectDirective) return;
                        ext.service.injectDirective(scope, _element);
                    }
                });
            }
        }
    };
}]);

/**
 * msExt bridge
 */
msExt.service('msExt', ['$templateCache', '$injector', '$rootScope', 'OptionSidebar', 'msDynamicSlots', 'bottomSheetItems', function ($templateCache, $injector, $rootScope, OptionSidebar, msDynamicSlots, bottomSheetItems) {
    /** @param $injector {{}} */

    /** @type {[msExtension]} */
    var extensions = [];

    /** @type {[{section: msSection, element: HTMLElement}]} */
    var sectionElements = [];

    /** @type {[msExtension]} */
    var inject_slot = [];

    var ext = {
        /**
         * get the HtmlElement for the given section
         * @param section {msSection}
         * @returns {HTMLElement|*}
         */
        getSectionElement: function (section) {
            for (var i = 0; i < sectionElements.length; i++) {
                if (section == sectionElements[i].section) {
                    return sectionElements[i].element;
                }
            }
            throw new Error('there is no element for the given section: ' + JSON.stringify(section));
        },

        /** @param section {msSection} */
        unregisterSection: function (section) {
            for (var i = 0; i < sectionElements.length; i++) {
                if (sectionElements[i].section == section) {
                    sectionElements[i].element = null;
                    sectionElements[i].section = null;
                    sectionElements.splice(i, 1);
                }
            }
        },

        /**
         * @param section {msSection}
         * @param element {HTMLElement}
         */
        registerSection: function (section, element) {
            sectionElements.push({
                'section': section,
                'element': element
            });
        },

        /** @returns {[msExtension]} */
        getExtensions: function () {
            return extensions;
        },

        /**
         * iterate over each extension
         * @param callback {function(ext: msExtension)}
         */
        forEachExtension: function (callback) {
            for (var i = 0; i < extensions.length; i++) {
                callback(extensions[i]);
            }
        },

        getExtension: function (name) {
            for (var i = 0; i < extensions.length; i++) {
                var ext = extensions[i];
                if (ext.name == name) {
                    return ext;
                }
            }
            return null;
        },

        initialize: function (scope) {
            if (extensions.length === 0) {
                listModuleComponents('msExt').forEach(
                    function (item) {
                        if (item[0] == 'msExt') return; // ignore msExt itself
                        if (item[1] != 'service') return; // services only
                        var key = item[0];

                        var service = $injector.get(key);

                        /** @type {msExtension|*} */
                        var extension = {
                            name: key,
                            key: key,
                            service: service,
                            config: null,
                            getState: null,
                            enabled: true
                        };

                        if (service.config) extension.config = service.config;
                        if (service.getState) extension.getState = service.getState;

                        if (extension.config && extension.config.enable_explicit) {
                            extension.enabled = false;
                        }
                        if (extension.config) {
                            OptionSidebar.registerEntry({
                                ext: extension,
                                key: extension.name,
                                title: extension.config.title,
                                parent_key: extension.config.extendConfig,
                                visible: extension.config.visible,
                                template: extension.config.template,
                                enable_explicit: extension.config.enable_explicit
                            });
                        }

                        if (service.type == 'slot') {
                            msDynamicSlots[key] = {
                                key: key,
                                name: key,
                                type: 'service',
                                service: service,
                                directive: null
                            };
                            bottomSheetItems.visible.push({name: service.title, 'type': key, icon: 'subject', 'default': ''});
                        }

                        extensions.push(extension);
                    });
            }
            return ext;
        },

        /**
         * @param scope {Object} - angular scope
         * @param context_element {HTMLBaseElement} - html element
         * @param [publish_action] {Boolean} - true for publish
         */
        siteLoaded: function (scope, context_element, publish_action) {
            scope.publish_action = publish_action;
            angular.forEach(extensions, function (item) {
                if (item.service.init) item.service.init(scope, context_element);
            });
            setTimeout(function () {
                $rootScope.$broadcast('msExtFinished', scope.mode.edit);
            });
        }
    };
    $rootScope.msExt = ext;

    /**
     * the key of the extension to enable.
     * @param {String} key
     */
    $rootScope.enableExplicit = function (key) {
        extensions.forEach(function (ext) {
            if (ext.name == key) {
                scope.site.settings.msExt[key] = true;
                // todo: console.log('enabled extension ', key);
            }
        });
        $rootScope.$applyAsync();
    };

    return ext;
}]);
